$(document).ready(function () {
	// Button search
	$('.filter-wrapper #search').click(function () {
		let filterList = [];

		$('.filter-wrapper .selected-value[data-value!=""]').each(function () {
			let $this = $(this);

			filterList.push($this.data('key') + '=' + $this.data('value'));
		});

		if (filterList.length) {
			location.href = location.pathname + '?' + filterList.join('&');
		}
		else {
			location.href = location.pathname;
		}
	});

	// Toggle filter menu
	$('.filter-wrapper .filter').click(function (event) {
		let $this = $(this);
		let hasClassActive = $this.hasClass('active');

		$('.filter-wrapper .filter').removeClass('active');

		if (hasClassActive) {
			$this.removeClass('active');
		}
		else {
			$this.addClass('active');
		}

		event.stopPropagation();
	});

	// Select value
	$('.filter-wrapper .list [data-value]').click(function (event) {
		let $this          = $(this);
		let $filter        = $this.parents('.filter');
		let $selectedValue = $filter.find('.selected-value');

		$selectedValue.attr('data-value', $this.data('value'));
		$selectedValue.html($this.data('caption'));
		$filter.find('.list .active[data-value]').removeClass('active');
		$this.addClass('active');

		$filter.removeClass('active');
		event.stopPropagation();
	});

	// Hide filter menu
	$(document).click(function () {
		$('.filter-wrapper .filter').removeClass('active');
	});
});
